import script from "./cardHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./cardHeader.vue?vue&type=script&setup=true&lang=ts"

import "./cardHeader.vue?vue&type=style&index=0&id=68abb1bc&scoped=true&lang=less"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68abb1bc"]])

export default __exports__